import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UsersToChangeModel } from "../UsersToChangeModel";

@Component({
	selector: "app-user-group-add-users",
	templateUrl: "./user-group-add-users.component.html",
	styleUrls: ["./user-group-add-users.component.css"],
})
export class UserGroupAddUsersComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.UserGroupID = this.dialogConfig.data.UserGroupID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadUserList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	//Data from Parent
	UserGroupID: any;
	UserLevelID: any = 0;
	SchoolID: any = 0;

	lstSchool: any = [];

	//Table Data
	lstUsers: any = [];
	SelectedUsers: any = [];
	OriginalUsers: any = [];
	lstUserLevelDesc: any = [];
	lstStatusDesc: any = [];

	RawUserData: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "UserName", header: "User Name" },
		{ field: "PersonName", header: "Person" },
		{ field: "UserLevelDesc", header: "User Level" },
		{ field: "StatusDesc", header: "Status" },
	];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadUserList() {
		this.loading = true;

		var result = this.sysAdminService.UserGetListByLevel(this.SchoolID, 2, this.UserLevelID);
		result.subscribe(
			(response) => {
				this.RawUserData = response;

				this.UpdateTableData();
			},
			(error) => {}
		);
	}

	UpdateTableData() {
		this.lstUsers = [];

		//Filter lists
		this.lstUserLevelDesc = [];

		for (var i = 0; i < this.RawUserData.length; i++) {
			var next = this.RawUserData[i];

			let val1: any = {
				UserID: next.UserID,
				UserName: next.UserName,
				PersonName: next.PersonName,
				UserLevelDesc: next.UserLevelDesc,
				StatusDesc: next.Active == 1 ? "Active" : "Inactive",
			};

			this.lstUsers = [...this.lstUsers, val1];
		}

		this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc))).sort();
		this.lstStatusDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.StatusDesc))).sort();

		this.UpdateSelected();

		this.loading = false;
	}

	UpdateSelected() {
		this.SelectedUsers = this.dialogConfig.data.SelectedUsers;
		this.OriginalUsers = this.dialogConfig.data.SelectedUsers;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//Get rid of roles that are already attached to the User Group
		var UsersToAdd = this.SelectedUsers.filter((user) => this.OriginalUsers.indexOf(user) == -1);

		//Create list of strings
		var lstUserID: number[] = [];

		for (var i = 0; i < UsersToAdd.length; i++) {
			var next = Number(UsersToAdd[i].UserID);
			lstUserID = [...lstUserID, next];
		}

		//Create Query Data
		let data: UsersToChangeModel = {
			UserGroupID: this.UserGroupID,
			UserIDs: lstUserID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupAddUsers(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add users to the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
